import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import BackSizes from '../selects/BackSizes';
import CupSizes from '../selects/CupSizes';
import { Back, Next } from '../ControlButtons';
import { BRAND_ADJUSTMENTS, CUP_COMPENSATION } from '../../data/constants';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage2 = ({
  backChange,
  backSize,
  backSizes,
  country,
  cupChange,
  cupSize,
  cupSizes,
  defaultNextProps,
  defaultPreviousProps,
  intl: { formatMessage },
  messages,
  resetSizeAndCaches,
  setBackSize,
  setBackSizes,
  setBackChange,
  setCupChange,
  setCupSize,
  setCupSizes,
  setTempBackCache,
  setTempCupCache,
  tempBackCache,
  tempCupCache,
  updateBack,
  updatedBackSize,
  updateCup,
  updatedCupSize,
  toggleCountry,
}) => {
  let disabled;
  if (cupSize && backSize) {
    disabled = false;
  } else {
    disabled = true;
  }

  const STAGE_NUMBER = '2';
  const STYLE_PREFIX = 'size-switcher';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <>
      <Back
        {...defaultPreviousProps(1, formatMessage(messages.changeBrand))}
        customFunc={resetSizeAndCaches}
      />
      <div className="stage stage-2">
        <div className="wrap">
          {window.location.href.indexOf('/us/') > -1 ? (
            <>
              <h2 className="fullWidth">
                {formatMessage(messages.stage2h5_us)}{' '}
                {country === 'en-US'
                  ? ' (US size)'
                  : ' (UK/International size)'}
              </h2>
            </>
          ) : (
            <h2 className="fullWidth">{formatMessage(messages.stage2h5)}</h2>
          )}
          <BackSizes
            backSizes={backSizes}
            setBackSize={setBackSize}
            setBackSizes={setBackSizes}
            setTempBackCache={setTempBackCache}
          />

          <CupSizes
            cupSizes={cupSizes}
            setCupSize={size => {
              updateCup({
                updateType: BRAND_ADJUSTMENTS,
                cup: size,
                numberOfSizes: cupChange,
                country,
                setCupSize,
              });
            }}
            setCupSizes={setCupSizes}
            setTempCupCache={size =>
              setTempCupCache({
                cupSize: updatedCupSize(size, cupChange, country),
                cupChange: 0,
              })
            }
            country={country}
          />

          {window.location.href.indexOf('/us/') > -1 && (
            <p className={STYLE_PREFIX}>
              If you are wearing a&nbsp;
              {country === 'en-US' ? ' UK ' : ' US '} sized bra, please&nbsp;
              <span
                className={`${STYLE_PREFIX}__toggle`}
                onClick={() => toggleCountry(country)}
              >
                click here
              </span>
              &nbsp;to switch {country === 'en-US' ? ' ' : ' back '} to
              {country === 'en-US' ? ' UK/International ' : ' US '} cup sizes.
            </p>
          )}

          <Next
            backSize={backSize}
            hasChevron
            disabled={disabled}
            {...defaultNextProps(1, 'Next question')}
            customFunc={() => {
              setCupChange(0);
              if (backChange !== 0) {
                const newBackSize = updatedBackSize({
                  sizeChange: backChange,
                  country,
                  backSize: tempBackCache,
                  cupSize: tempCupCache.cupSize,
                });
                if (newBackSize) {
                  updateBack({
                    updateType: BRAND_ADJUSTMENTS,
                    newBackSize,
                    setBackSize,
                    setTempBackCache,
                    setBackChange,
                  });
                  return;
                }
                updateCup({
                  updateType: CUP_COMPENSATION,
                  cup: cupSize,
                  numberOfSizes: backChange,
                  country,
                  setCupSize,
                });
                setBackChange(0);
                setTempBackCache(backSize);
                setTempCupCache({
                  cupSize: updatedCupSize(cupSize, backChange, country),
                  cupChange: 0,
                });
                return;
              }
              // If back hasn't changed then cache
              setTempBackCache(backSize);
              setTempCupCache({
                cupSize: cupSize,
                cupChange: cupChange,
              });
            }}
          />
        </div>
      </div>
    </>
  );
};

export default injectIntl(Stage2);

Stage2.propTypes = {
  Back: PropTypes.func,
  backChange: PropTypes.number,
  backSize: PropTypes.string,
  backSizes: PropTypes.array,
  country: PropTypes.string,
  cupChange: PropTypes.number,
  cupSize: PropTypes.string,
  cupSizes: PropTypes.string,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  resetSizeAndCaches: PropTypes.func,
  setBackChange: PropTypes.func,
  setBackSize: PropTypes.func,
  setBackSizes: PropTypes.func,
  setCupSize: PropTypes.func,
  setCupSizes: PropTypes.func,
  setCupChange: PropTypes.func,
  setTempBackCache: PropTypes.func,
  setTempCupCache: PropTypes.func,
  tempBackCache: PropTypes.string,
  tempCupCache: PropTypes.object,
  toggleCountry: PropTypes.func,
  updateBack: PropTypes.func,
  updatedBackSize: PropTypes.func,
  updateCup: PropTypes.func,
  updatedCupSize: PropTypes.func,
};
